import { useScrollAnim } from "../../hook/useScrollAnim";
import img1 from "../../../assets/img/projects/People/people-img-1.png";
import img2 from "../../../assets/img/projects/People/people-img-2.png";
import img3 from "../../../assets/img/projects/People/people-img-3.png";

function r(min, max) {
  return Math.random() * (max - min) + min;
}
function randomStyle(i) {
  // offsets aléatoires (en vw/vh pour s’adapter à l’écran)
  const fromX = `${r(-40, 40).toFixed(1)}vw`;
  const fromY = `${r(-30, 30).toFixed(1)}vh`;
  const rot = `${r(-12, 12).toFixed(1)}deg`;
  const dur = `${r(0.6, 0.95).toFixed(2)}s`;
  const del = `${(0.08 * i + r(0, 0.06)).toFixed(2)}s`; // léger stagger

  return {
    // variables CSS pour la transition & la pose initiale
    "--fromX": fromX,
    "--fromY": fromY,
    "--rot": rot,
    "--dur": dur,
    "--del": del,
  };
}

export default function Images() {
  const containerRef = useScrollAnim({
    selector: ".people-images img",
    threshold: 0.2,
    once: true,
  });

  return (
    <section className="people-images" ref={containerRef}>
      <div className="side-img">
        <div>
          <img
            style={randomStyle(0)}
            src={img1}
            alt="Plat signature du restaurant"
          />
        </div>
        <div>
          <img style={randomStyle(1)} src={img3} alt="Détail de la salle" />
        </div>
      </div>
      {/* <img
        style={randomStyle(2)}
        src={img2}
        alt="Ambiance terrasse du restaurant"
      /> */}
    </section>
  );
}
